import React, { useEffect, useState } from "react"
import { Route, Redirect } from "react-router-dom"
import { Spinner } from "reactstrap"
import { getCurrentUser } from "../auth.utils"
import "./privateRoute.css"
import ThemeAdmin from "../../components/ExtraComponents/ThemeAdmin"

export const PrivateRoute = ({ component: Component, ...props }) => {
  const [authorize, setAuthorize] = useState(false),
    [loading, setLoading] = useState(true)

  useEffect(() => {
    getCurrentUser()
      .then((data) => {
        if (data) {
          setAuthorize(true)
        }
        setLoading(false)
      })
      .catch(() => {
        setAuthorize(false)
        setLoading(false)
      })
  }, [])

  return loading ? (
    <div className="d-flex align-items-center justify-content-center spinner_container">
      <Spinner size="lg" className="spinner" />
    </div>
  ) : (
    <Route
      {...props}
      render={props =>
        authorize ? (
          <ThemeAdmin>
            <Component {...props} />
          </ThemeAdmin>
        ) : (
          <Redirect
            to={{
              pathname: "/sign-in",
              state: { from: props.location }
            }}
          />
        )
      }
    />
  )
}
